import { categories } from "@/mocks/categories";

interface CategoryGridProps {
  title: string;
  subtitle: string;
  startIndex: number;
  count: number;
}

const cardColors = [
  "bg-primary-50/60",
  "bg-accent-50/60",
  "bg-secondary-50/60",
  "bg-background-100",
];

export default function CategoryGrid({ title, subtitle, startIndex, count }: CategoryGridProps) {
  const displayCategories = categories.slice(startIndex, startIndex + count);

  return (
    <section className="py-20 md:py-28 px-6 md:px-12 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <p className="text-xs font-semibold tracking-widest text-foreground-400 uppercase mb-4 font-sans">
            Catégories Produits
          </p>
          <h2 className="text-3xl md:text-5xl lg:text-6xl">
            <span className="block font-bold text-foreground-950 font-heading">
              {title}
            </span>
            <span className="block italic font-light text-foreground-600 font-heading mt-1">
              {subtitle}
            </span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {displayCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-3xl overflow-hidden cursor-pointer"
            >
              {/* Image area */}
              <div
                className={`relative aspect-[4/5] overflow-hidden ${
                  cardColors[(startIndex + idx) % cardColors.length]
                }`}
              >
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} - Hipobuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  title={`${cat.name} - Hipobuy Spreadsheet`}
                />
              </div>
              {/* Label */}
              <div className="bg-background-50 py-4 px-1">
                <span className="inline-block text-xs md:text-sm font-medium text-foreground-700 font-sans px-4 py-2 rounded-full border border-background-300/60 group-hover:border-primary-300/60 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}